const articleDb = [
  {
    img: `https://drive.google.com/uc?export=view&id=1LCtKjfUoWulvMjyjIlRuFpjHSvDtvAQZ`,
    name: `Top 10 LANDSCAPES(Namibia)2019`,
    categories: [`nature`],
    text: `The Landscaping in Namibia are breath taking unique post apocalyptic and just yearning for a world class picture to display just about anywhere here we have just a few of the best`,
    more: `https://camelthornetree.firebaseapp.com/top-10-landscapes/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1J_mSWYJbeKCdaPYvH6dzK6rym12UZxdK`,
    name: `Top 10 Pork Dishes(Namibia)2019`,
    categories: [`food`],
    text: `The list below is Made of Pork Dishes Served across the country even though locals have been making them for decades they where more popular during the year 2019,they`,
    more: `https://camelthornetree.firebaseapp.com/top-10-pork-dishes/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1IrypFBbxKVUtyIaieUMb5inLr6J_8gkd`,
    name: `Top 10 Salons(Namibia)2019`,
    categories: [`fashion`],
    text: `The list below has some of the unique and creative hair studios in Windhoek this Salons as they are named in Namibia had one of`,
    more: `https://camelthornetree.firebaseapp.com/top-10-salon/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1GfU4YuRP7O5Kdh0gRo8XUXhaOcT2YLlU`,
    name: `Top 10 Books(Namibia)2019`,
    categories: [`art`],
    text: `The list below has the most read books of adventure reference to episodes that took place in Namibia and Southern Africa this set of books where written by Authors and published by studios from all around the world`,
    more: `https://camelthornetree.firebaseapp.com/top-10-books/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1DPP_S-9s74BhWlV7Q9Z4veaOLir_Le2E`,
    name: `Top 10 SUV's(Namibia)2019`,
    categories: [`automobile`],
    text: `The list below is made up of just the small portion of sports utility vehicles that where used to explore the vast majority of the Namibian roads the list was created to cut out the mediocre`,
    more: `https://camelthornetree.firebaseapp.com/top-10-suv/`,
  },
{
    img: `https://drive.google.com/uc?export=view&id=1BsF9W1DlJrnPILAxTTRfeTWdjD7KBMEh`,
    name: `Top 10 Art Galleries(Namibia)2019`,
    categories: [`art`],
    text: `Today we will look at local art Markets where to find them and some of their background trades and aspects this art centers are not the only creative centers in the`,
    more: `https://camelthornetree.firebaseapp.com/top-10-art-galleries/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1922n_7nC3yaAy0bFQlUtsMrO_rZtQTKS`,
    name: `Top 10 Pesticides(Namibia)2019`,
    categories: [`agriculture`],
    text: `The list below contains Pesticides conventional Namibian farmers imported from neighbouring governments and international traders to supplement their farming practices`,
    more: `https://camelthornetree.firebaseapp.com/top-10-pesticides/`,
  },
{
    img: `https://drive.google.com/uc?export=view&id=17kNcaFjJmUZLuMHucd-GV6DxxEwfiAoO`,
    name: `Top 10 Hotels(Namibia)2019`,
    categories: [`accomodation`],
    text: `The list below consist of the popular hotels and designated lodges along Namibia longest stretched highway the B1 Highway that runs diagonally across the center of the country infamously`,
    more: `https://camelthornetree.firebaseapp.com/top-10-hotels/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=14J1UOmMeFkI5V5KwtdSbmDDdO2CHfJ_d`,
    name: `Top 10 Tech Products(Namibia)2019`,
    categories: [`technology`],
    text: `The list we have today consists on Gadgets and Modern Tech that might set you back on pricing but they make up for it in quality and recommendations we conjured up just some of this`,
    more: `https://camelthornetree.firebaseapp.com/top-10-tech-products/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=124DRdwwtlzEa0Vk2noZZIPPkgB0FLCK_`,
    name: `Top 10 Sports Events(Namibia)2019`,
    categories: [`sport`],
    text: `The list we will go through today has extremely hard endurance sports from around the world that are way more difficult to complete in Namibia then elsewhere we followed some of them up`,
    more: `https://camelthornetree.firebaseapp.com/top-10-sport-events/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-lo22iZOwHgRHMFLbebWeVVux4t7SOtI`,
    name: `Top 10 Marine Animals(Namibia)2019`,
    categories: [`nature`],
    text: `
The list below is made of the most intriguing and wonderful marine wildlife that roam the Namibian ocean a lot of mysteries and myths where foretold by natives about this`,
    more: `https://camelthornetree.firebaseapp.com/top-10-marine-wildlife/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-C8MBXMCRpjwzkYz1SZH4pQcS250X5CQ`,
    name: `Top 10 Mutton Dishes(Namibia)2019`,
    categories: [`food`],
    text: `The following are food servings that have been popular demand around gourmet kitchens and restaurants throughout the country but have their origins elsewhere around the world`,
    more: `https://camelthornetree.firebaseapp.com/top-10-mutton-dishes/`,
  },
{
    img: `https://drive.google.com/uc?export=view&id=14DbTgrIKmK1FTrwkXqckcbAeJh6XUqa9`,
    name: `Top 10 Fashion Shows(Namibia)2019`,
    categories: [`fashion`],
    text: `This list has the 10 outstanding designers of the 2019 Windhoek Fashion Week there where more than 30 designers and we had to cut this list down to the once we think made a impressive`,
    more: `https://camelthornetree.firebaseapp.com/top-10-fashion-shows/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-NdWnHS29r9VqBGCBOR1ig0CYag9jKuB`,
    name: `Top 10 Music Artist(Namibia)2019`,
    categories: [`art`],
    text: `This list has a mixture of artist from a variety of mixed rich music genre we chose this list on bases of popularity artistic influence and finance and some unique attributes the artist`,
    more: `https://camelthornetree.firebaseapp.com/top-10-artist-mixed/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1482x2N4WjuhTWxWHw6sdlhSUY42Opg7B`,
    name: `Top 10 Craft Markets(Namibia)2019`,
    categories: [`art`],
    text: `Today we will look at local art Markets where to find them and some of their background trades and aspects this art centers are not the only creative centers in the`,
    more: `https://camelthornetree.firebaseapp.com/top-10-craft-markets/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=10xFL7FKRmM7UTJeCidGK6GzXXUAYTEYo`,
    name: `Top 10 Sedans(Namibia)2019`,
    categories: [`automobile`],
    text: `The list is made up of Family class Sedans that made a suitable run during the last quarter of 2019 this cars are just not worth their seset value they are equally`,
    more: `https://camelthornetree.firebaseapp.com/top-10-midsize-sedans/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=1x3bl8LNny86PuMKnSbUR3VvGNNB7QBMp`,
    name: `Top 10 AWD Sedans(Namibia)2019`,
    categories: [`automobile`],
    text: `This list contains a variety of All Wheel Drive vehicles driven across Namibia Cars are suitable to the the Namibian road terrain`,
    more: `https://camelthornetree.firebaseapp.com/top-10-awd-cars/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-QcAfUESK_cxQl5-hffc-CUFdvOEl4PM`,
    name: `Top 10 Bakkies(Namibia)2019`,
    categories: [`automobile`],
    text: `Here we have the top 10 Bakkies (Pickups) in Namibia in 2019 remember to post a comment at the bottom of the list.We will work this list down starting from the top most popular and work our way`,
    more: `https://camelthornetree.firebaseapp.com/top-10-bakkies/`,
  },
{
    img: `https://drive.google.com/uc?export=view&id=1-u4PSGhzaAqTK4sI1gUkGxRmoTVErgbO`,
    name: `Top 10 Art & Cultural Festivals(Namibia)2019`,
    categories: [`art`],
    text: `The following are the most popular art and cultural festivals held during 2019 their attendance was fair to reasonable and guest had a`,
    more: `https://camelthornetree.firebaseapp.com/top-10-cutural-festivals/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-KKdTEFNLdDCi7VQnqKBeruuUOtp4FQv`,
    name: `Top 10 Predators(Namibia)2019`,
    categories: [`nature`],
    text: `This list contains a variety of ensembled majestic wildlife in Namibia. it's a simple list starting from the most dominant and running down.This specie's are a`,
    more: `https://camelthornetree.firebaseapp.com/top-10-majestic-predators/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=11qANrDIRsgDzPELG075N05ARSm31R3X2`,
    name: `Top 10 Fashion Designers(Namibia)2019`,
    categories: [`fashion`],
    text: `This list consist of Fashion designers in their late 20's and early 30's that have been doing some great work and setting a morally acceptable trend that could actually be marketed on the African`,
    more: `https://camelthornetree.firebaseapp.com/top-10-foreign-designers/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=1--oo_czU2OWjrEhn7nspV5DXMnj4auw9`,
    name: `Top 10 Livestock Medication(Namibia)2019`,
    categories: [`agriculture`],
    text: `This list is progressive there's still more improvements to come  but for the time being this is what we could conjure up with some of the most imported medications that local farmers used on their`,
    more: `https://camelthornetree.firebaseapp.com/top-10-livestock-medication/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=10GnnPtEk6UVn4n72bNVlIsYzV76jWRcg`,
    name: `Top 10 Laptops(Namibia)2019`,
    categories: [`technology`],
    text: `The list below contains laptop devices Namibian users have been working with and preferred more than the rest this list of laptops and Notebooks are economically`,
    more: `https://camelthornetree.firebaseapp.com/top-10-expandable-laptops/`,
  },
  {
	img: `https://drive.google.com/uc?export=view&id=1-MadsgarkBKjaz6uP2ZWdyfQkhOZrsW5`,
    name: `Top 10 Youth Hostels(Namibia)2019`,
    categories: [`accomodation`],
    text: `This list is made up of resting camps and hostels young backpackers repeatedly explore when in regional capitals they are the more popular of the bunch we have created this`,
    more: `https://camelthornetree.firebaseapp.com/top-10-youth-resting-camps/`,
    },
    {
    img: `https://drive.google.com/uc?export=view&id=19SD4ffeZArZL2a94FdnjGAy9atsvR9DZ`,
    name: `Top 10 Livestock Auctions(Namibia)2019`,
    categories: [`agriculture`],
    text: `This list contains most important auctions sites if you are in the livestock business run through it and make some turns around this`,
    more: `https://camelthornetree.firebaseapp.com/top-10-livestock-auctions/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-nLtq64PNOx5kagbQKJgp2ztzLSQK0ds`,
    name: `Top 10 Smartphones(Namibia)2019`,
    categories: [`technology`],
    text: `Here we will be looking at some of the phones from around the world that have become popular among locals here I have haphazardly selected some handset to make a proper list that actually makes sense`,
    more: `https://camelthornetree.firebaseapp.com/top-10-budget-smartphones/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-bS1AOtroJhpuN2OmzdXo6KmDU0Qwbxy`,
    name: `Top 10 Fast Foods(Namibia)2019`,
    categories: [`gastronomy`],
    text: `Today's top 10 is quite a nifty little one, we tried to avoid street food as much as we could and tried to build a list that contains original fast-food. comparable to those that would be`,
    more: `https://camelthornetree.firebaseapp.com/top-10-fast-foods/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=1-IiSDIwBbACiZZ9nuqA5y0Q8qVLIb6qR`,
    name: `Top 10 Plants(Namibia)2019`,
    categories: [`nature`],
    text: `The Following list has one of the rare some endemic and some regional plant and some celebrated plant species in the Southern Western African Region this list has some`,
    more: `https://camelthornetree.firebaseapp.com/top-10-plant-species/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=1BJRjzDEbfT3gONTRgb9_XwTPv_lGGEuz`,
    name: `Top 10 Crops(Namibia)2019`,
    categories: [`agriculture`],
    text: `This list has one of the most prominently used and cultivated crops in Namibia it's i tried to make it as fair as i could justifying the crops angle of`,
    more: `https://camelthornetree.firebaseapp.com/top-10-harvested-crops/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-tVrsPQ1m_e3CGV2SGKH_yZaLFs2-59d`,
    name: `Top 10 Varmints(Namibia)2019`,
    categories: [`nature`],
    text: `This list contains animals that aren't on the usual radar of on lookers but have special abilities that set them apart and would've been amazing in almost anyway had they been on`,
    more: `https://camelthornetree.firebaseapp.com/top-10-varmints/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=10CgedT-ALLKtplRL4iJZPWuY_H9BpVfH`,
    name: `Top 10 Althletes(Namibia)2019`,
    categories: [`sport`],
    text: `This list was something tricky to build with so many well disciplined athletes in so many sports across the country, but with so many options to choose`,
    more: `https://camelthornetree.firebaseapp.com/top-10-athletes/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-fOVLbrsNPuxf1BhlcYh0cYODxhlZdsx`,
    name: `Top 10 B&B's(Namibia)2019`,
    categories: [`accomodation`],
    text: `Today we will be looking at Bed & Breakfast accommodations in Windhoek and it's surroundings the list will go as usual starting from the best and down the list contains B&B this are places reserved for`,
    more: `https://camelthornetree.firebaseapp.com/top-10-bnb/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=16Cfl_PqBkVhoBAwEtdiLsQen_wkSmF7D`,
    name: `Top 10 Chicken Dishes(Namibia)2019`,
    categories: [`gastronomy`],
    text: `This is a list of most popular International Chicken Meals available in the country's homes and eateries this list has no customary introduction we went`,
    more: `https://camelthornetree.firebaseapp.com/top-10-chicken-dishes/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1-XILuwQf4iYecIZFQdnU4vbbe1fOeusU`,
    name: `Top 10 Beef Products(Namibia)2019`,
    categories: [`agriculture`],
    text: `I wrote this article with much anticipation it is no secret that Namibians do love their meat we will be running through our list of processed and preprocessed meat cuts`,
    more: `https://camelthornetree.firebaseapp.com/top-10-beef/`,
  },
    {
    img: `https://drive.google.com/uc?export=view&id=1E7mpyP2GUwLMM8AHXghkUDL6UuHqFGHT`,
    name: `Top 10 Beef Dishes(Namibia)2019`,
    categories: [`gastronomy`],
    text: `A conventional braised beef stew with thick, rich gravy, a usually suitable dish for those who don't mind cheap cuts as long as they're thoroughly cooked which most often guarantees a`,
    more: `https://camelthornetree.firebaseapp.com/beef-dishes/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=10tBM2Ac0lzmR3UHFp2Di5-Eqc_wW70OA`,
    name: `Top 10 Fashion Stores(Namibia)2019`,
    categories: [`fashion`],
    text: `On this weeks countdown, we will be looking at Foreign-owned Fashion stores that have been around this blocks for more or less most of its growth stages investing in hard`,
    more: `https://camelthornetree.firebaseapp.com/top-10-foreign-fashion-stores/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=13RY1mpxSOh1ecLMkwNG0b6-V2p_0U_Ls`,
    name: `Top 10 Sport Disciplines(Namibia)2019`,
    categories: [`sport`],
    text: `Today we will be looking at sports and clubs that are still maintaining a healthy lifestyle even at the adversary of finance and equipment constantly`,
    more: `https://camelthornetree.firebaseapp.com/top-10-sports-disciplines/`,
  },
  {
    img: `https://drive.google.com/uc?export=view&id=1000RmADKJIY-sWkWIJM9TEdSntgdR8ap`,
    name: `Top 10 Camp Sites(Namibia)2019`,
    categories: [`accomodation`],
    text: `This list has a quick review of the most visited and reasonably save camping sides down the coast of Namibia they are highly recommended by most vistors the Namibian western`,
    more: `https://camelthornetree.firebaseapp.com/top-10-camp-sites/`,
  },
];

// eslint-disable-next-line import/prefer-default-export
export function get({ filter = {}, limit, page = 1 }) {
  const pageInt = parseInt(page, 10);

  return new Promise((resolve) => {
    setTimeout(() => {
      let result = articleDb;
      let filteredResultCount = result.length;

      if (filter.category) {
        result = result.filter(x => x.categories.includes(filter.category));
        filteredResultCount = result.length;
      }

      if (limit) {
        const start = (pageInt - 1) * limit;
        const end = start + limit;
        result = result.slice(start, end);
      }
      resolve({
        data: result,
        meta: {
          pageCount: Math.ceil(filteredResultCount / limit),
        },
      });
    }, 500);
  });
}
